export default __webpack_public_path__ + "static/media/MapImage.26d987f2.webp";